// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__Ff-Rb","modalForm":"UpgradeEpcsModal_modalForm__fj9ar","modalFooter":"UpgradeEpcsModal_modalFooter__2vwFZ"};